if (!customElements.get("ac-interactive-product-app")) {
  class AcInteractiveProductApp extends HTMLElement {
    constructor() {
      super();
      this._handleHotspotTap = this._handleHotspotTap.bind(this);
      this._handleSwipe = this._handleSwipe.bind(this);
      this._closeMobileDrawer = this._closeMobileDrawer.bind(this);
    }
    connectedCallback() {
      this._tabList = this.querySelector("ona-tablist");
      this._tabPanels = this.querySelectorAll("ona-tabpanel");
      this._viewport = this.querySelector(".interactive-product-app__viewport");
      this._mobileDrawer = this.querySelector(".interactive-product-app__mobile-drawer");
      this._tabList.addEventListener("change", () => {
        this._viewport.classList.toggle("interactive-product-app__viewport--toggled");
      });
      this._viewport.addEventListener("touchstart", (e) => {
        this._touchStartX = e.changedTouches[0].screenX;
      });
      this._viewport.addEventListener("touchend", (e) => {
        this._touchEndX = e.changedTouches[0].screenX;
        this._handleSwipe();
      });
      this._tabPanels.forEach((tp) => {
        tp.addEventListener("click", (e) => {
          const tabPanel = e.currentTarget;
          if (tabPanel.hidden) {
            tabPanel.tabElement.click();
          }
        });
      });
      this._mobileMediaQuery = window.matchMedia("(max-width: 1279px)");
      this._mobileMediaQuery.addEventListener("change", (e) => {
        this._initMobileDrawer(e.matches);
      });
      this._initMobileDrawer(this._mobileMediaQuery.matches);
    }
    _handleSwipe() {
      const distance = this._touchEndX - this._touchStartX;
      if (Math.abs(distance) > 50) {
        if (distance > 0) {
          this._tabList.querySelector("ona-tab:first-child").click();
        } else {
          this._tabList.querySelector("ona-tab:last-child").click();
        }
      }
    }
    _handleHotspotTap(e) {
      this._openInMobileDrawer(e.target.closest(".interactive-product-app__feature"));
    }
    _initMobileDrawer(isMobile) {
      if (!isMobile && !this._isMobileInitialized) return;
      const hotspots = this.querySelectorAll(".interactive-product-app__feature-hotspot");
      hotspots.forEach((hotspotEl) => {
        if (isMobile) {
          hotspotEl.addEventListener("click", this._handleHotspotTap);
        } else {
          hotspotEl.removeEventListener("click", this._handleHotspotTap);
        }
      });
      if (!this._inViewObserver) {
        this._inViewObserver = new IntersectionObserver(
          ([entry]) => {
            const isInView = entry.isIntersecting;
            if (!isInView && this._mobileMediaQuery.matches) {
              this._closeMobileDrawer();
            }
          },
          { threshold: 0.6 }
        );
        this._inViewObserver.observe(this);
      }
      this._isMobileInitialized = true;
    }
    _openInMobileDrawer(featureEl) {
      const mobileDrawerEl = this.querySelector(".interactive-product-app__mobile-drawer");
      const template = mobileDrawerEl.querySelector("template");
      const drawerContentEl = template.content.cloneNode(true);
      drawerContentEl.querySelector(".interactive-product-app__feature-title").innerHTML = featureEl.querySelector(
        ".interactive-product-app__feature-title"
      ).innerHTML;
      drawerContentEl.querySelector(".interactive-product-app__feature-description").innerHTML = featureEl.querySelector(".interactive-product-app__feature-description").innerHTML;
      drawerContentEl.querySelector(".interactive-product-app__feature-heading").prepend(featureEl.querySelector(".interactive-product-app__feature-icon").cloneNode(true));
      const replaceCard = () => {
        var _a;
        (_a = mobileDrawerEl.querySelector(".interactive-product-app__feature-mobile-card")) == null ? void 0 : _a.remove();
        mobileDrawerEl.append(drawerContentEl);
        mobileDrawerEl.classList.add("interactive-product-app__mobile-drawer--open");
        mobileDrawerEl.querySelector(".interactive-product-app__mobile-drawer-close-button").addEventListener("click", this._closeMobileDrawer, { once: true });
      };
      if (!document.startViewTransition) {
        replaceCard();
      } else {
        const card = drawerContentEl.querySelector(".interactive-product-app__feature-mobile-card");
        card.style.viewTransitionName = "interactive-product-app-mobile-card";
        document.startViewTransition(replaceCard);
      }
    }
    _closeMobileDrawer() {
      const mobileDrawerEl = this.querySelector(".interactive-product-app__mobile-drawer");
      mobileDrawerEl.classList.remove("interactive-product-app__mobile-drawer--open");
    }
  }
  customElements.define("ac-interactive-product-app", AcInteractiveProductApp);
}
